/* eslint-disable react/jsx-handler-names */
import React from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'redux';

import {
    handleApplyFilter as handleApplyFilterAction,
    handleRemoveFilter as handleRemoveFilterAction,
    handleRemoveAllFilters as handleRemoveAllFiltersAction,
    searchByBBoxOrPlace as searchByBBoxOrPlaceAction,
    handleRemoveOnlineFilter,
} from '../../../../SearchApp/actions/search';
import {
    openCloseAnimatedDrawer as openCloseAnimatedDrawerAction,
    setFilterTypeToShow as setFilterTypeToShowAction,
} from '../../../../SearchApp/actions/ui';

import {
    getSelectedFilterCount,
    getSelectedDate,
    getSelectedCategory,
    getSelectedFormat,
} from '../../../../SearchApp/selectors/search';

// TODO Update loadable logic for filter panels
import { FilterPanelDesktop } from '../../components/FilterPanel';
const FilterPanelMobile = loadable(
    () => import(/* webpackPrefetch: true */ '../../components/FilterPanel'),
    {
        resolveComponent: (components) => components.FilterPanelMobile,
    },
);

import { FOLLOWED_ORGS_FILTER_VALUE } from '../../../../SearchApp/constants';
import { CUSTOM_DATE } from '../../../../constants';

export class FilterPanel extends React.PureComponent {
    static propTypes = {
        /**
         * Callback for when filters are applied
         */
        handleApplyFilter: PropTypes.func,
        /**
         * Callback for when filters are removed
         */
        handleRemoveFilter: PropTypes.func,
        /**
         * Type of individual filter to show in the filter panel
         * or '' if all filters must be shown
         */
        filterTypeToShow: PropTypes.string,
        /**
         * Boolean for if mobile filter panel should be displayed
         */
        isAnimatedDrawerOpen: PropTypes.bool,
    };

    _handleChange = (key, value, shouldUpdateRoute) => {
        const { handleApplyFilter, handleRemoveFilter } = this.props;

        if (value === 'all') {
            handleRemoveFilter({ [key]: true });
        } else {
            handleApplyFilter({ [key]: value }, {}, shouldUpdateRoute);
        }
    };

    _handleCustomDate = (startDate, endDate) => {
        const { handleApplyFilter } = this.props;

        handleApplyFilter({ dates: CUSTOM_DATE }, { startDate, endDate });
    };

    render() {
        const {
            selectedFilterCount,
            isAnimatedDrawerOpen,
            filterTypeToShow,
            openCloseAnimatedDrawer,
            selectedFilters,
            handleRemoveFilter,
            locationSlug,
            isBotRequest,
            handleRemoveAllFilters,
            setFilterTypeToShowAction,
            isAuthenticated,
            isLoading,
            languageCode,
            handleApplyOnlineFilter,
            handleRemoveOnlineFilter,
        } = this.props;

        const SHARED_FILTER_PROPS = {
            isAuthenticated,
            languageCode,
            selectedFilterCount: selectedFilterCount,
            handleApplyOnlineFilter,
            handleRemoveOnlineFilter,
            onFilterChange: this._handleChange,
            onCustomDateChange: this._handleCustomDate,
        };

        return (
            <>
                <aside className="search-base-screen__filter-panel">
                    <FilterPanelDesktop
                        {...SHARED_FILTER_PROPS}
                        filterTypeToShow={filterTypeToShow}
                        handleDrawerSelect={setFilterTypeToShowAction}
                        handleRemoveAllFilters={handleRemoveAllFilters}
                        handleRemoveFilter={handleRemoveFilter}
                        isBotRequest={isBotRequest}
                        locationSlug={locationSlug}
                        selectedFilters={selectedFilters}
                        isLoading={isLoading}
                    />
                </aside>
                {isAnimatedDrawerOpen && (
                    <div>
                        <FilterPanelMobile
                            {...SHARED_FILTER_PROPS}
                            filterTypeToShow={filterTypeToShow}
                            handleRemoveFilter={handleRemoveFilter}
                            openCloseAnimatedDrawer={openCloseAnimatedDrawer}
                            selectedFilters={selectedFilters}
                            isLoading={isLoading}
                        />
                        {/* eslint-disable-next-line react/no-danger */}
                        <style
                            dangerouslySetInnerHTML={{
                                __html: `
                          .eds-structure {
                            position: fixed;
                            width: 100%;
                            height: 100%;
                          }
                        `,
                            }}
                        />
                    </div>
                )}
            </>
        );
    }
}

const _mapStateToProps = (state) => ({
    selectedFilterCount: getSelectedFilterCount(state),
    isAnimatedDrawerOpen: state.ui.isAnimatedDrawerOpen,
    filterTypeToShow: state.ui.filterTypeToShow,
    isBotRequest: state.app.isBotRequest,
    locationSlug: state.location.slug,
    isAuthenticated: state.auth.isAuthenticated,
    languageCode: state.app.languageCode,
    selectedFilters: {
        price: state.search.eventSearch.price,
        tags: getSelectedCategory(state.search.eventSearch.tags),
        format: getSelectedFormat(state.search.eventSearch.tags),
        dates: getSelectedDate(
            state.search.eventSearch.dates,
            state.search.eventSearch.dateRange,
        ),
        currencies:
            state.search.eventSearch.currencies.length > 0
                ? state.search.eventSearch.currencies[0]
                : '',
        languages:
            state.search.eventSearch.languages.length > 0
                ? state.search.eventSearch.languages
                : '',
        followedOrganizers:
            state.search.eventSearch.special.indexOf(
                FOLLOWED_ORGS_FILTER_VALUE,
            ) > -1,
        organizations: state.search.eventSearch.organizationsOr.length
            ? state.search.eventSearch.organizationsOr
            : [],
        hash: state.search.eventSearch.hash,
        isOnline: state.search.eventSearch.onlineEventsOnly,
    },
    isLoading: state.pagination.loading,
});

const _mapDispatchToProps = (dispatch, ownProps) => ({
    handleApplyFilter: (...args) =>
        dispatch(handleApplyFilterAction(ownProps.history, ...args)),
    handleRemoveFilter: (...args) =>
        dispatch(handleRemoveFilterAction(ownProps.history, ...args)),
    handleRemoveAllFilters: (...args) =>
        dispatch(handleRemoveAllFiltersAction(ownProps.history, ...args)),
    openCloseAnimatedDrawer: (...args) =>
        dispatch(openCloseAnimatedDrawerAction(...args)),
    setFilterTypeToShowAction: (...args) =>
        dispatch(setFilterTypeToShowAction(...args)),
    handleApplyOnlineFilter: (...args) =>
        dispatch(searchByBBoxOrPlaceAction(ownProps.history, ...args)),
    handleRemoveOnlineFilter: (...args) =>
        dispatch(handleRemoveOnlineFilter(ownProps.history, ...args)),
});

const enhance = compose(
    withRouter,
    connect(_mapStateToProps, _mapDispatchToProps),
);

export const FilterPanelContainer = enhance(FilterPanel);
